import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=auth
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password, totp) => {
    const { data } = await api.post("/auth/login", { email, password, totp });
    if (data.require_totp) return { require_totp: true };
    setUser(data.user);
    return { ok: true };
  };
  const logout = async () => { try { await api.post("/auth/logout"); } catch {} setUser(false); };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}
